import type { TileImage, Variation, VariationV2 } from '@shared/types/types.ts';
import type { ProductLink } from '@tile/components/product-title/ProductLink';
import type { ProductTitle } from '@tile/components/product-title/ProductTitle.ts';
import { mapFashionTitle } from '@tilelist/layouts/mapping/ProductTitle.ts';
import { mapLink } from '../mapping/ProductLink';

export type FashionLayout = {
    /**
 *
 */
    readonly variation: Variation | VariationV2;

    /**
 *
 */
    readonly title: ProductTitle;

    readonly link: ProductLink;

    readonly images: TileImage[];
};

/**
 *
 */
export function createFashionLayout(variation: Variation | VariationV2): FashionLayout {
    return {
        variation,
        title: mapFashionTitle(variation),
        link: mapLink(variation),
        images: getImages(variation),
    };
}

function getImages(variation: Variation | VariationV2): TileImage[] {
    return 'images' in variation ? variation.images.slice(0, 3) : [variation.image];
}
